import type * as Types from '../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateBillMutationVariables = Types.Exact<{
  tariffCode: Types.Scalars['String']['input'];
  months: Types.Scalars['Int']['input'];
}>;


export type CreateBillMutationPage = { readonly __typename?: 'RootMutationType', readonly createBill: { readonly __typename?: 'YalperBill', readonly id: string } };

export type RequestUltraTariffMutationVariables = Types.Exact<{
  months: Types.Scalars['Int']['input'];
}>;


export type RequestUltraTariffMutationPage = { readonly __typename?: 'RootMutationType', readonly requestUltraTariff: boolean };

export type RequestBankPaymentMutationVariables = Types.Exact<{
  tariffCode: Types.Scalars['String']['input'];
  months: Types.Scalars['Int']['input'];
}>;


export type RequestBankPaymentMutationPage = { readonly __typename?: 'RootMutationType', readonly requestBankPayment: boolean };


export const CreateBillDocument = gql`
    mutation CreateBill($tariffCode: String!, $months: Int!) {
  createBill(tariffCode: $tariffCode, months: $months) {
    id
  }
}
    `;
export type CreateBillMutationFn = Apollo.MutationFunction<CreateBillMutationPage, CreateBillMutationVariables>;

/**
 * __useCreateBillMutation__
 *
 * To run a mutation, you first call `useCreateBillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBillMutation, { data, loading, error }] = useCreateBillMutation({
 *   variables: {
 *      tariffCode: // value for 'tariffCode'
 *      months: // value for 'months'
 *   },
 * });
 */
export function useCreateBillMutation(baseOptions?: Apollo.MutationHookOptions<CreateBillMutationPage, CreateBillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBillMutationPage, CreateBillMutationVariables>(CreateBillDocument, options);
      }
export type CreateBillMutationHookResult = ReturnType<typeof useCreateBillMutation>;
export type CreateBillMutationResult = Apollo.MutationResult<CreateBillMutationPage>;
export type CreateBillMutationOptions = Apollo.BaseMutationOptions<CreateBillMutationPage, CreateBillMutationVariables>;
export const RequestUltraTariffDocument = gql`
    mutation RequestUltraTariff($months: Int!) {
  requestUltraTariff(months: $months)
}
    `;
export type RequestUltraTariffMutationFn = Apollo.MutationFunction<RequestUltraTariffMutationPage, RequestUltraTariffMutationVariables>;

/**
 * __useRequestUltraTariffMutation__
 *
 * To run a mutation, you first call `useRequestUltraTariffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestUltraTariffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestUltraTariffMutation, { data, loading, error }] = useRequestUltraTariffMutation({
 *   variables: {
 *      months: // value for 'months'
 *   },
 * });
 */
export function useRequestUltraTariffMutation(baseOptions?: Apollo.MutationHookOptions<RequestUltraTariffMutationPage, RequestUltraTariffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestUltraTariffMutationPage, RequestUltraTariffMutationVariables>(RequestUltraTariffDocument, options);
      }
export type RequestUltraTariffMutationHookResult = ReturnType<typeof useRequestUltraTariffMutation>;
export type RequestUltraTariffMutationResult = Apollo.MutationResult<RequestUltraTariffMutationPage>;
export type RequestUltraTariffMutationOptions = Apollo.BaseMutationOptions<RequestUltraTariffMutationPage, RequestUltraTariffMutationVariables>;
export const RequestBankPaymentDocument = gql`
    mutation RequestBankPayment($tariffCode: String!, $months: Int!) {
  requestBankPayment(tariffCode: $tariffCode, months: $months)
}
    `;
export type RequestBankPaymentMutationFn = Apollo.MutationFunction<RequestBankPaymentMutationPage, RequestBankPaymentMutationVariables>;

/**
 * __useRequestBankPaymentMutation__
 *
 * To run a mutation, you first call `useRequestBankPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestBankPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestBankPaymentMutation, { data, loading, error }] = useRequestBankPaymentMutation({
 *   variables: {
 *      tariffCode: // value for 'tariffCode'
 *      months: // value for 'months'
 *   },
 * });
 */
export function useRequestBankPaymentMutation(baseOptions?: Apollo.MutationHookOptions<RequestBankPaymentMutationPage, RequestBankPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestBankPaymentMutationPage, RequestBankPaymentMutationVariables>(RequestBankPaymentDocument, options);
      }
export type RequestBankPaymentMutationHookResult = ReturnType<typeof useRequestBankPaymentMutation>;
export type RequestBankPaymentMutationResult = Apollo.MutationResult<RequestBankPaymentMutationPage>;
export type RequestBankPaymentMutationOptions = Apollo.BaseMutationOptions<RequestBankPaymentMutationPage, RequestBankPaymentMutationVariables>;